import React, { useEffect, useState } from "react";
import "../styles.css";
import "bootstrap/dist/css/bootstrap.css";
import CreatableSelect from "react-select/creatable";
import {
  getLabels,
  getTag,
  getSampleData,
  postPersonSchema,
  finalizeImport,
} from "api/AccountsApi";
import { toast } from "react-toastify";
var FormData = require("form-data");

//Data Model selectDropDownData : {label:"" value:"" }

function TagContact(props) {
  const [dataApi, setDataApi] = useState("");
  const [dataTag, setDataTag] = useState("");
  const [showpreviewButton, setShowpreviewButton] = useState(false);
  const [showTableData, setShowTableData] = useState(false);
  const [selectDropDownData, setSelectDropDownData] = useState();
  const [createColumns, setCreateColumns] = useState();
  const [createDropdownColumn, setcreateDropdownColumn] = useState();
  const [noofAccount, setnoofAccount] = useState(0);
  const [duplicate, setduplicate] = useState();
  const [dropdownvaluesarray, setdropdownvaluesarray] = useState([]);
  const [ignoredFileAttributes, setignoredFileAttributes] = useState([]);
  const [personSchemaSnapshotArray, setPersonSchemaSnapshotArray] = useState(
    []
  );
  const [emailMissing, setEmailMissing] = useState(false);
  const [selectionIsMandatory, setSelectionIsMandatory] = useState(false);

  var checkArray = [];
  var ignoreArray = [];

  //User Effect
  useEffect(() => {
    var post_data = new FormData();
    var getdata = sessionStorage.getItem("KWlogId");
    post_data.append("logId", getdata.split(",")[0]);

    getTag()
      .then((data) => {
        let j = 0;
        let tags = [];
        data.map((datatag) => {
          j++;
          tags.push({
            value: datatag.tag,
            label: datatag.tag,
          });
          if (data.length === j) {
            setDataTag(tags);

          }
        });
      })
      .catch((e) => { })

    post_data &&
      getSampleData(post_data)
        .then((sampledata) => {
          setDataApi(sampledata.sampleData);
          var object1 = sampledata.sampleData[0];
          setcreateDropdownColumn(Object.keys(object1));

          let i = 0;
          let col = [
            {
              value: "ignore",
              label: "Ignore",
              key: "ignore",
            },
          ];
          setnoofAccount(sampledata.numberOfRecords);
          getLabels()
            .then((labeldata) => {
              labeldata.map((column) => {

                i++;

                col.push({
                  value: column.label,
                  label: column.label,
                  key: column.key,
                  isBaseSchema: column.isBaseSchema,
                });
                if (labeldata.length === i) {
                  setCreateColumns(col);
                }
              });
            })
            .catch((e) => { })
        })
        .catch((e) => { })
  }, []);

  //finalize import
  const FinalizeImport = () => {
    for (let i = 0; i < selectDropDownData.length; i++) {
      checkArray.push(selectDropDownData[i].value);
    }
    for (let i = 0; i < ignoredFileAttributes.length; i++) {
      if (!ignoredFileAttributes[i] == "") {
        ignoreArray.push(i);
      }
    }
    let personSchema = [];
    personSchemaSnapshotArray.map((obj, index) => {
      if (obj !== "ignore") {
        let object = { key: obj, fileAttributeIndex: index };
        personSchema.push(object);
      }
    });



    var getdata = sessionStorage.getItem("KWlogId");

    var data = JSON.stringify({
      logId: getdata.split(",")[0],
      mergeFlag: getdata.split(",")[2],
      subscriptionStatus: getdata.split(",")[1],
      isProspectFile: getdata.split(",")[3],
      tags: checkArray,
      ignoredFileAttributes: ignoreArray,
      personSchemaSnapshot: personSchema,
    });

    finalizeImport(data)
      .then((data) => {
        toast.success(
          "The data file upload has been scheduled. You will receive an email with the status when it's complete."
        );
      })
      .catch((error) => {

      });
  };
  //Check for duplicate and ignore in the Column dropdown
  function checkForDuplicates(dropdownvaluesarray) {
    let valuesAlreadySeen = [];

    for (let i = 0; i < dropdownvaluesarray.length; i++) {
      let value = dropdownvaluesarray[i];
      if (value == "ignore") {

      } else {
        if (valuesAlreadySeen.indexOf(value) !== -1) {
          return true;
        }
        valuesAlreadySeen.push(value);
      }
    }
    return false;
  }
  //Validate before final import
  const validate = () => {
    if (checkForDuplicates(dropdownvaluesarray)) {

      setduplicate(true);
    } else {
      if (!personSchemaSnapshotArray.includes("email")) {
        setEmailMissing(true);
        setduplicate(false);
        return;
      }
      if (
        personSchemaSnapshotArray.includes(null) ||
        personSchemaSnapshotArray.includes(undefined)
      ) {
        setSelectionIsMandatory(true);

        setduplicate(false);
        setEmailMissing(false);
        return;
      }
      if (
        personSchemaSnapshotArray.length < createDropdownColumn.length &&
        createDropdownColumn
      ) {
        toast.info("Fill all the records");
        setduplicate(false);
        return;
      } else {
        setduplicate(false);
        FinalizeImport();

        routeChangetocancel();

      }
    }
  };

  const ShowTable = () => {
    setShowTableData(true);
  };

  const data = dataApi;

  const columns = createColumns;

  //Handling the changes in the tags
  const handleChangeTags = (newValue, actionMeta) => {

    setSelectDropDownData(newValue);
    setShowpreviewButton(true);
  };

  //Handling the changes in Columns DropDown
  const handleChangeColumns = (newValue, actionMeta, idx) => {

    var __new = true;
    if (actionMeta.option == undefined) {
      __new = false;
    }


    //@boney task: send only label for new schema
    //

    if (newValue.value != null && __new == true) {
      //issue in first index
      //for new create
      let newArr = [...dropdownvaluesarray];
      newArr[idx] = newValue.value;
      setdropdownvaluesarray(newArr);


      var data = {
        label: newValue.value,
        fileAttribute: createDropdownColumn[idx],
      };


      postPersonSchema(data)
        .then((data) => {

          let temp = personSchemaSnapshotArray;
          temp[idx] = data.key;
          setPersonSchemaSnapshotArray(temp);
        })
        .catch((error) => {

        });
    } else {
      if (newValue.value == "ignore") {
        let newArr = [...dropdownvaluesarray];
        let newPersonArr = [...personSchemaSnapshotArray];
        let ignoredArr = [...ignoredFileAttributes];
        newArr[idx] = newValue.value;
        newPersonArr[idx] = newValue.value;
        //ignoredArr[idx] = createDropdownColumn[idx];

        setignoredFileAttributes(ignoredArr);
        setdropdownvaluesarray(newArr);
        setPersonSchemaSnapshotArray(newPersonArr);
      } else {
        // for existing select
        let newArr = [...dropdownvaluesarray];
        let ignoredArr = [...ignoredFileAttributes];
        ignoredArr[idx] = "";
        newArr[idx] = newValue.value;
        setignoredFileAttributes(ignoredArr);


        setdropdownvaluesarray(newArr);
        var data = {
          label: newValue.value,
          key: newValue.key,
          fileAttribute: createDropdownColumn[idx],
        };

        let temp = personSchemaSnapshotArray;
        temp[idx] = data.key;
        setPersonSchemaSnapshotArray(temp);
        // if in base schema then send label+key else dont post
        if (newValue.isBaseSchema) {
          postPersonSchema(data)
            .then((schemaData) => {

            })
            .catch((error) => {

            });
        }
      }
    }

  };

  const handleInputChangeColumns = (inputValue, actionMeta) => {
    // console.group("Input Changed");
    // 
    // 
    // console.groupEnd();
  };

  // 

  //Mapping the columns for dropdown
  const mapDropdownTableColumns = () => {
    return (
      createDropdownColumn &&
      createDropdownColumn.map((col, index) => {
        var data = col;
        var idx = index;
        // 

        return (
          <th id="mapping_table" key={idx}>
            <div style={style.dropdown}>
              <CreatableSelect
                isClearable
                onChange={(newValue, metadata) => {
                  if (newValue !== null) {
                    handleChangeColumns(newValue, metadata, idx);
                  } else {
                    let newArr = [...personSchemaSnapshotArray];
                    newArr[idx] = null;
                    setPersonSchemaSnapshotArray(newArr);


                  }
                }}
                onInputChange={handleInputChangeColumns}
                options={columns}
              />
            </div>
          </th>
        );

      })
    );
  };

  //Column Data from Api
  const mapTableColumns = () => {
    return (
      createDropdownColumn &&
      createDropdownColumn.map((col) => {
        return (
          <th
            style={{
              display: "flex",
              justifyContent: "space-between",
              margin: "1vw",
              width: "9vw",
              overflow: "hidden",
            }}
          >
            {col}
          </th>
        );
      })
    );
  };

  //Row Data From Api
  const mapTableRowData = (i) => {
    // 
    let rowdata = Object.values(i);
    return rowdata.map((obj) => {

      return (
        <td
          style={{
            margin: "1vw",
            display: "flex",
            flexWrap: "wrap",
            overflow: "hidden",
            width: "9vw",
          }}
        >
          {obj}
        </td>
      );
    });
  };

  const routeChangetocancel = () => {
    let path = `/admin/contact/add`;
    props.history.push(path);
  };


  return (
    <div>
      <div className="page_heading">
        <div className="row">
          <div className="col-lg-6">
            <h2>Tag Your Contacts</h2>
            <p>
              Easily organize your contacts using simple words or phrases that
              makes the most sense to you.
            </p>
          </div>
        </div>
      </div>
      <div className="tag_contacts_outer">
        <div className="row">
          <div className="col-lg-5">
            <div class="inputOuter">
              <label>Search for or create tags</label>

              <div style={style.dropdown2}>
                <CreatableSelect
                  isMulti
                  isClearable
                  onChange={handleChangeTags}
                  options={dataTag}
                />
              </div>
            </div>
          </div>
        </div>

        {showpreviewButton ? (
          <div className="btn-wrap">
            <input
              onClick={ShowTable}
              type="submit"
              class="lg_btn primary mt-3"
              value="Continue to Match"
            />
          </div>
        ) : (
          ""
        )}

        {showTableData ? (
          <div className="contact_table-wrap mt-4">
            <div className="card-inn-heading mb-4">
              <h2>Match column labels to contact information</h2>
            </div>
            <div className="text-wrap">
              <p>{noofAccount} contacts were recognized in this file.</p>
            </div>
            <div>
              {duplicate ? (
                <p style={{ color: "red" }}>Duplicate labels not allowed</p>
              ) : emailMissing ? (
                <p style={{ color: "red" }}>Email selection is Mandatory</p>
              ) : selectionIsMandatory ? (
                <p style={{ color: "red" }}>Column selection is Mandatory</p>
              ) : (
                ""
              )}
            </div>
            {/* Data Table to map Data */}

            <div style={style.table}>
              <table>
                <table>
                  <thead
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <tr>{mapDropdownTableColumns()}</tr>
                  </thead>
                </table>
                <thead style={style.column}>
                  <tr
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      overflow: "hidden",
                    }}
                  >
                    {mapTableColumns()}
                  </tr>
                </thead>
                <tbody
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    overflow: "hidden",
                    flexWrap: "wrap",
                    // margin: "1vh",
                    // alignContent: "flex-end",
                  }}
                >
                  {data &&
                    data.map((obj, i) => {
                      return (
                        <tr
                          style={{
                            display: "flex",
                            overflow: "hidden",
                            // justifyContent: "space-between",
                            flexWrap: "no-wrap",
                          }}
                          key={i}
                        >
                          {mapTableRowData(obj)}
                        </tr>
                      );
                    })}
                </tbody>
              </table>
            </div>
            <p>"(*)"Keep Typing to create field</p>
            <div className="tag_contact_table mt-4">
              {/* <div className="contact_table_footer"></div> */}
              <div class="btn-wrap mt-2">
                <div className="upload-btn-wrap mr-3">
                  <a
                    href="javascript:void(0);"
                    onClick={validate}
                    class="lg_btn primary"
                  >
                    {/* <input type="file" class="file_upload"/>   */}
                    Finalize Import
                  </a>
                </div>

                <div className="upload-btn-wrap" style={{ marginLeft: 10 }}>
                  <a
                    href="javascript:void(0);"
                    onClick={routeChangetocancel}
                    class="lg_btn tertiary"
                  >
                    {/* <input type="file" class="file_upload"/>   */}
                    Cancel
                  </a>
                </div>
              </div>
            </div>
          </div>
        ) : (
          ""
        )}
      </div>
    </div>
  );
}

const style = {
  fontFamily: "Poppins",
  table: {
    overflowX: "scroll",
    minHeight: "60vh",
  },
  dropdown: {
    width: "9vw",
    margin: "0.9vw",
  },
  dropdown2: {
    width: 400,
  },
  column: {
    fontWeight: "bold",
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
  },
};

export default TagContact;
